export default "__VITE_ASSET__2b74ed27__"